// src/components/WhyUs.js
import React from "react";

const reasons = [
  { num: "01", title: "Fast Delivery", desc: "Agile processes and dedicated teams ensure your project ships on time, every time." },
  { num: "02", title: "Custom Solutions", desc: "No templates, no shortcuts. Every solution is engineered specifically for your business goals." },
  { num: "03", title: "Scalable Systems", desc: "We build infrastructure that grows with you — from 100 to 10 million users." },
  { num: "04", title: "Ongoing Support", desc: "We don't disappear after launch. Dedicated post-delivery maintenance and technical support." },
  { num: "05", title: "Transparent Process", desc: "Weekly updates, clear timelines, and full visibility into every step of your project." },
  { num: "06", title: "Expert Engineers", desc: "Senior engineers with real-world experience across Data, Web, and Marketing domains." },
];

function WhyUs() {
  return (
    <section className="why-us" id="why-us">
      <div className="section-inner">

        <div className="section-header" style={{textAlign:"center"}}>
          <div className="section-tag" style={{margin:"0 auto 20px"}}>
            <i className="fas fa-star"></i> Why Choose Us
          </div>
          <h2 className="section-title">Why 10+ Businesses Trust MechFolks</h2>
          <p className="section-subtitle" style={{margin:"0 auto"}}>
            We combine technical expertise with a genuine commitment to your business growth —
            delivering results you can measure.
          </p>
        </div>

        <div className="why-grid">
          {reasons.map((r, i) => (
            <div className="why-card" key={i}>
              <div className="why-number">{r.num}</div>
              <h3>{r.title}</h3>
              <p>{r.desc}</p>
            </div>
          ))}
        </div>

        {/* Process Section */}
        <div style={{marginTop: "80px"}}>
          <div className="section-header" style={{textAlign:"center"}}>
            <div className="section-tag" style={{margin:"0 auto 20px"}}>
              <i className="fas fa-route"></i> Our Process
            </div>
            <h2 className="section-title">How We Work</h2>
            <p className="section-subtitle" style={{margin:"0 auto 60px"}}>
              A simple, proven 4-step process from idea to launch.
            </p>
          </div>

          <div className="process-steps">
            {[
              { step: "01", title: "Discovery", desc: "We understand your goals, challenges, and target audience in a free consultation." },
              { step: "02", title: "Strategy", desc: "We craft a detailed roadmap tailored to your business requirements and timeline." },
              { step: "03", title: "Build", desc: "Our engineers execute with precision using agile sprints and weekly check-ins." },
              { step: "04", title: "Launch & Grow", desc: "We deploy, monitor, and support your product continuously post-launch." },
            ].map((p, i) => (
              <div className="process-step" key={i}>
                <div className="step-circle">{p.step}</div>
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default WhyUs;
